import {ActivityDto, BiszDto, BiszVariantDto, BlockDto, BlockTypeEnum, ElementDto, ElementNavigationTypeEnum, IconDto, MasteringTypeEnum, MediaContentDto, MenuElementDto, SideEnum, SlideDto} from "@rsmu/oep-api";
import { EducationProgressInterface } from "./interfaces/education-progress.interface";
import { EducationStepInterface } from "./interfaces/education-step.interface";
import { StepTypeEnum } from "./enums/step-type.enum";
import { MediaTypeEnum } from "./enums/media-type.enum";
import { OepQuiz } from "./oep-quiz.class";
import { EducationProgressTypeEnum } from "./enums/education-progress.enum";

export class OepStep  implements EducationStepInterface {
    id: string;
    name: string;
    icon?: IconDto;
    type: string;
    navigationType?: string;
    enabled?: boolean;
    showLock?: boolean;
    required?: boolean;
    passed?: boolean;
    progress?: EducationProgressInterface;
    showFlag?: boolean;
    accordion?: boolean;
    opened?: boolean;
    text?: string;
    activity?: ActivityDto;
    bisz?: BiszDto;
    biszResults?: BiszVariantDto[];
    certificateId?: false | string;
    slider?: SlideDto[];
    mediaContent?: MediaContentDto;

    blocks?: EducationStepInterface[] | undefined;
    quiz?: OepQuiz;
    parent?: EducationStepInterface;
    sideMenu?: MenuElementDto[]  | undefined  | null;

    constructor({
        id,
        name,
        icon,
        type,
        navigationType,
        enabled,
        showLock,
        required,
        passed,
        progress,
        showFlag,
        accordion,
        opened,
        text,
        activity,
        bisz,
        biszResults,
        certificateId,
        slider,

        blocks,
        quiz,
        parent,
        sideMenu,
        mediaContent

    } : EducationStepInterface) {
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.type = type;
        this.navigationType = navigationType;
        this.enabled = enabled;
        this.showLock = showLock;
        this.required = required;
        this.passed = passed;
        this.progress = progress;
        this.showFlag = showFlag;
        this.accordion = accordion;
        this.opened = opened;
        this.text = text;
        this.activity = activity;
        this.bisz = bisz;
        this.biszResults = biszResults;
        this.certificateId = certificateId;
        this.slider = slider;

        this.blocks = blocks;
        this.quiz = quiz;
        this.parent = parent;
        this.sideMenu = sideMenu;
        this.mediaContent = mediaContent;
    }

    static parseStepRecursiveFromDto(dto: ElementDto | BlockDto, parent?: OepStep): EducationStepInterface {
        const stepType = OepStep.mapIomDtoElementsTypeToStepType(dto);
        const navigationType = 'elements' in dto ? dto.navigationType : undefined;
        const required = 'elements' in dto ? dto.required : undefined;
        const passed = 'elements' in dto ? dto.passed : undefined;
        const showFlag = 'elements' in dto ? dto.showFlag : undefined;
        const accordion = 'accordion' in dto ? (dto as BlockDto).accordion : undefined;
        const opened = 'opened' in dto ? (dto as BlockDto).opened : undefined;
        const text = 'text' in dto ? (dto as BlockDto).text : undefined;
        const activity = 'activity' in dto ? (dto as BlockDto).activity : undefined;
        const mediaContent = 'mediaContent' in dto ? dto.mediaContent : undefined;
        const bisz = 'bisz' in dto ? dto.bisz : undefined;
        const biszResults = 'biszResults' in dto ? dto.biszResults : undefined;
        const certificateId = 'certificateId' in dto ? dto.certificateId : undefined;
        const slider = 'slider' in dto ? dto.slider : undefined;

        let preSteps: Array<ElementDto | BlockDto> = [];
        if ('type' in dto && dto.menuElements) {
            preSteps = dto.menuElements;
        } else {
            const allMenuElements = OepStep.getAllMenuElements(dto as ElementDto);
            const allElements = [...((dto as ElementDto).blocks ?? []), ...((dto as ElementDto).elements ?? [])];
            if (allElements.length) {
                preSteps = allElements;
                if (allMenuElements) {
                    allMenuElements.forEach((el) => {
                        const index = preSteps.findIndex((s) => s.id === el.id);
                        if (index !== -1) preSteps.splice(index, 1);
                    });
                }
            } else if (allMenuElements?.length) {
                preSteps = allMenuElements;
            }
        }

        const step = new OepStep ({
            id: dto.id || '',
            name: dto.name || '',
            icon: dto.icon,
            type: stepType,
            navigationType: navigationType,
            enabled: !dto.enabled,
            showLock: dto.showLock,
            required: required,
            passed: passed,
            progress: OepStep.mapMasteredDtoToEducationProgress(dto),
            showFlag: showFlag,
            accordion: accordion,
            opened: opened,
            text: text,
            activity: activity,
            bisz: bisz,
            biszResults: biszResults,
            certificateId: certificateId,
            slider: slider,
            mediaContent: mediaContent,

            blocks: undefined,
            quiz: 'type' in dto && (dto.type === BlockTypeEnum.TESTING || dto.type === BlockTypeEnum.TESTING_RESULTS)
            ? OepQuiz.mapBlockDtoToOepQuiz(dto)
            : undefined,
            parent: parent,
            sideMenu: 'sideMenu' in dto ? (dto as ElementDto).sideMenu ?? undefined : null,
         });
            step.blocks = preSteps.map(el => this.parseStepRecursiveFromDto(el, step));
            return step;
    }

    static getAllMenuElements (dto: ElementDto): ElementDto[] | null {
        const blocks = dto.blocks?.filter((b: BlockDto) => b.type === BlockTypeEnum.MENU);
        if (blocks?.length) {
            let result: ElementDto[] = [];
            blocks.forEach(b => {
                result = result.concat(b.menuElements ?? [])
            });
            return result;
        }
        return null;
    }

    static mapIomDtoElementsTypeToStepType (dto: ElementDto | BlockDto): StepTypeEnum {

        let stepType = StepTypeEnum.Text;

        if(!('type' in dto)) {
          stepType = StepTypeEnum.Step;
          return stepType;
        }

        switch(dto.type) {
            case BlockTypeEnum.MENU: {
                stepType = StepTypeEnum.Menu
                break;
            }
            case BlockTypeEnum.TESTING: {
                stepType = StepTypeEnum.QuizGeneral;
                break;
            }
            case BlockTypeEnum.TESTING_RESULTS: {
                stepType = StepTypeEnum.QuizVariant;
                break;
            }
            case BlockTypeEnum.ISZ: {
                stepType = StepTypeEnum.IszGeneral;
                break;
            }
            case BlockTypeEnum.ISZ_RESULTS: {
                stepType = StepTypeEnum.IszVariant;
                break;
            }
            case BlockTypeEnum.SLIDER: {
                stepType = StepTypeEnum.Slider;
                break;
            }
            case BlockTypeEnum.MEDIA_CONTENT: {
                stepType = StepTypeEnum.MediaContent;
                break;
            }
            case BlockTypeEnum.CERTIFICATE: {
                stepType = StepTypeEnum.Certificate
            }
        }
        return stepType;
    }

    static mapIomDtoActivityTypeToStepMedia (blockDto: BlockDto): ActivityDto | null {
        let activity: ActivityDto | undefined;
        let mediaType: MediaTypeEnum;

        activity = blockDto.activity;
        if(!activity) { return null };

        switch(blockDto.activity?.mediaContent?.type) {
            case "VIDEO_LINK": {
              mediaType = MediaTypeEnum.Link;
              break;
            }
            case "LINK":
            {
                mediaType = MediaTypeEnum.Link;
                break;
            }
            case "PICTURE": {
                mediaType = MediaTypeEnum.ShowImageInDialog;
                break;
            }
            case "VIDEO": {
                mediaType = MediaTypeEnum.ShowVideoInDialog;
                break;
            }
            default: {
                mediaType = MediaTypeEnum.Download;
            };
        }

        activity = {
            name: activity.name,
            icon: activity?.icon,
            side: activity?.side === 'LEFT' ? SideEnum.LEFT : SideEnum.RIGHT,
            materialType: activity?.materialType,
            mediaContent: activity.mediaContent,
        }
        return activity;
    }

    static mapMasteredDtoToEducationProgress (dto: BlockDto | ElementDto): EducationProgressInterface | undefined {
        let progress: EducationProgressInterface | undefined;
        let progressType: EducationProgressTypeEnum;
        let value: number | undefined = undefined;

        switch(dto.mastered?.type) {
            case MasteringTypeEnum.FACT: {
                progressType = EducationProgressTypeEnum.FACT;
                break;
            }
            case MasteringTypeEnum.SCALE: {
                progressType = EducationProgressTypeEnum.SCALE;
                value = dto.mastered?.score || 0
                break;
            }
            default: {
                progressType = EducationProgressTypeEnum.FACT;
            }
        }

        progress = dto.mastered ? {
            type: progressType,
            mandatory: dto.mastered?.mandatory,
            mandatoryOption: dto.mastered?.mandatoryOption,
            mastered: dto.mastered?.mastered,
            value: value,
            color: '#00C043',
        } : undefined;

        return progress;
    }

}
